<template>
  <ErrorModal />
  <q-dialog v-model="show" persistent class="modal-general add-user-modal">
    <q-card style="min-width: 350px">
      <q-form @submit="createNewUser()">
        <q-card-section class="row">
          <q-icon name="las la-2x la-plus-square" class="icon-color-addorg" />

          <div class="add-user-heading bold-font">Add new user</div>
        </q-card-section>

        <q-separator />
        <div class="row">
          <div class="column">
            <q-card-section class="q-pt-none">
              <div class="row justify-around q-pt-md">
                <q-input
                  v-model="user.email"
                  borderless
                  bg-color="white"
                  type="email"
                  label="Email"
                  :rules="[isValidEmail, requiredFieldRule]"
                  dense
                  style="width: 250px"
                />
              </div>

              <div class="row justify-around">
                <q-input
                  dense
                  v-model="user.person.firstName"
                  label="Input first name"
                  :rules="requiredFieldRule"
                  borderless
                  bg-color="white"
                  style="width: 250px"
                />
              </div>
              <div class="row justify-around">
                <q-input
                  dense
                  v-model="user.person.lastName"
                  label="Input last name"
                  :rules="requiredFieldRule"
                  borderless
                  bg-color="white"
                  style="width: 250px"
                />
              </div>
              <div class="row justify-around q-mb-md">
                <q-input
                  dense
                  v-model="user.person.department"
                  label="Input department"
                  borderless
                  bg-color="white"
                  style="width: 250px"
                />
              </div>

              <div class="row justify-around">
                <q-input
                  borderless
                  bg-color="white"
                  style="width: 250px"
                  filled
                  dense
                  v-model="user.person.startDate"
                  label="Start date"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="user.person.startDate"
                          mask="DD-MM-YYYY"
                          :options="startDateOptionsFn"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div class="row justify-around">
                <q-input
                  borderless
                  bg-color="white"
                  style="width: 250px"
                  filled
                  dense
                  v-model="user.person.endDate"
                  label="End date"
                  class="q-pt-md"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="user.person.endDate"
                          mask="DD-MM-YYYY"
                          :options="endDateOptionsFn"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div class="row justify-around">
                <q-select
                  borderless
                  bg-color="white"
                  v-model="user.person.salutation"
                  label="Select salutation"
                  :options="salutations"
                  option-label="description"
                  option-value="id"
                  emit-value
                  map-options
                  style="width: 250px"
                  behavior="menu"
                  dense
                  class="q-pt-md"
                  :rules="requiredFieldRuleSalutation"
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>

              <q-checkbox
                v-show="isSuperAdmin"
                class="q-ml-md"
                v-model="user.person.isAccountManager"
                label="Accountmanager"
                color="indigo-10"
              >
                <q-tooltip>
                  This user is AccountManager.
                </q-tooltip>
              </q-checkbox>
            </q-card-section>
          </div>
          <div class="column">
            <q-card-section class="q-pt-md">
              <div class="row justify-around" v-if="customerHasContent">
                <q-select
                  borderless
                  bg-color="white"
                  v-model="user.person.contentRoleId"
                  label="Select content role"
                  :options="contentRolesForCreate"
                  option-label="name"
                  option-value="id"
                  emit-value
                  map-options
                  style="width: 250px"
                  behavior="menu"
                  dense
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
              <q-toggle
                v-if="customerHasContent"
                v-model="user.person.isReceivingSystemMails"
                label="Receiving system e-mails"
                color="indigo-10"
              >
                <q-tooltip>
                  These are the in-activity and onboarding emails.
                </q-tooltip>
              </q-toggle>
              <div class="row justify-around q-pt-md">
                <q-select
                  v-if="customerHasSas"
                  borderless
                  bg-color="white"
                  v-model="user.person.sasRoleId"
                  label="Select SAS role"
                  :options="sasRolesForCreate"
                  option-label="name"
                  option-value="id"
                  emit-value
                  map-options
                  style="width: 250px"
                  behavior="menu"
                  dense
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="row justify-around q-pt-md" v-if="user.person.sasRoleId">
                <q-input
                  borderless
                  bg-color="white"
                  style="width: 250px"
                  filled
                  dense
                  v-model="user.person.sasStartDate"
                  label="Sas start date"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="user.person.sasStartDate"
                          mask="DD-MM-YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <q-toggle
                v-if="customerHasSas"
                v-model="user.person.receivesTaskEmails"
                label="Receiving task e-mails"
                color="indigo-10"
              >
              </q-toggle>
              <fieldset
                v-if="customerHasSas"
                class="sas-categorizations"
                aria-describedby="sasCategorizationsHint"
              >
                <legend class="sas-categorizations__legend bold-font">
                  SAS categorizations
                </legend>
                <p id="sasCategorizationsHint" class="sas-categorizations__hint">
                  {{ sasCategorizationsHint }}
                </p>
                <div class="row justify-around">
                  <q-select
                    multiple
                    borderless
                    bg-color="white"
                    v-model="user.firstCategories"
                    :label="firstCategorization.parentName || 'First categorization'"
                    :options="firstCategorization.categories || []"
                    :disable="!targetCustomerHasSas || !firstCategorization.parentId"
                    option-label="name"
                    option-value="id"
                    emit-value
                    map-options
                    style="width: 250px"
                    behavior="menu"
                    dense
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>

                <div class="row justify-around q-pt-md">
                  <q-select
                    multiple
                    borderless
                    bg-color="white"
                    v-model="user.secondCategories"
                    :label="secondCategorization.parentName || 'Second categorization'"
                    :options="secondCategorization.categories || []"
                    :disable="!targetCustomerHasSas || !secondCategorization.parentId"
                    option-label="name"
                    option-value="id"
                    emit-value
                    map-options
                    style="width: 250px"
                    behavior="menu"
                    dense
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
              </fieldset>
            </q-card-section>
          </div>
        </div>

        <q-separator />
        <q-card-actions align="around">
          <q-btn
            class="orange-btn-filled bold-font"
            no-caps
            label="Save"
            type="submit"
          />
          <q-btn
            class="orange-btn bold-font"
            no-caps
            label="Cancel"
            @click="openCancelPopup()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>

  <q-dialog
    v-model="cancelDialog"
    persistent
    transition-show="scale"
    transition-hide="scale"
  >
    <q-card style="width: 300px">
      <q-card-section>
        <div>Are you sure you want to cancel?</div>
      </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn
          no-caps
          flat
          label="Yes"
          @click="disableAdd()"
          class="orange-btn-filled bold-font"
        />
        <q-btn
          no-caps
          flat
          label="No"
          class="orange-btn bold-font"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, onMounted, computed, reactive } from "vue";
import store from "../../store/index.js";
import { useRouter } from "vue-router";
import ErrorModal from "./ErrorModal";
import UserService from "../../services/user.service.js";
import moment from "moment";
export default {
  props: {
    showAdd: Boolean,
    filterByActivityStatus: String,
    customerId: Number,
  },
  components: {
    ErrorModal,
  },
  setup(props) {
    const router = useRouter();
    const show = ref(props.showAdd);
    const user = reactive({
      email: "",
      firstCategories: [],
      secondCategories: [],
      person: {
        firstName: "",
        lastName: "",
        salutation: 3,
        customer: null,
        department: "",
        isReceivingSystemMails: true,
        isAccountManager: false,

        // If has content fields
        startDate: moment().format("DD-MM-YYYY"),
        sasStartDate: null,
        endDate: null,
        contentRoleId: null,

        // If has sas fields
        sasRoleId: null,
        receivesTaskEmails: false,
      },
    });

    const prefilledCustomer = computed({
      get: () => store.state.user.prefilledCustomer,
    });

    const firstCategorization = computed({
      get: () => store.state.user.firstCategorization,
    });
    const secondCategorization = computed({
      get: () => store.state.user.secondCategorization,
    });
    const cancelDialog = ref(false);
    const openCancelPopup = () => {
      cancelDialog.value = true;
    };

    onMounted(async () => {
      await UserService.getAllSalutations();
      await UserService.getRolesForCreateUser();
      await UserService.getSasCategories(prefilledCustomer.value && prefilledCustomer.value.id > 0 ? prefilledCustomer.value.id : props.customerId);
      if (prefilledCustomer.value.id > 0) {
        user.person.customer = {
          name: prefilledCustomer.value.name,
          value: prefilledCustomer.value.id,
        };
      }
    });

    const contentRolesForCreate = computed({
      get: () => store.state.user.contentRolesForCreate,
    });
    const sasRolesForCreate = computed({
      get: () => store.state.user.sasRolesForCreate,
    });
    const disableAdd = () => {
      store.commit("user/disableAdd");
    };

    const showReactivateSoftDeletedUserModal = computed({
      get: () => store.state.user.showReactivateSoftDeletedUserModal,
    });

    const custId = ref(props.customerId);
    const filterActivity = ref(props.filterByActivityStatus);

    const createNewUser = async () => {
      await UserService.checkIfSoftDeletedUserExists(
        user.email,
        user.person.customer.value
      ).then(async (response) => {
        if (response.status === 200) {
          if (showReactivateSoftDeletedUserModal.value) {
            disableAdd();
            store.commit(
              "user/updateModalError",
              "A user with this email already exists, but is deleted."
            );
            store.commit("user/enableModalError");
            return;
          }
          if (prefilledCustomer.value && prefilledCustomer.value.id > 0) {
            user.person.customer = {
              name: prefilledCustomer.value.name,
              value: prefilledCustomer.value.id,
            };
          }
          await UserService.createUser(user);
        }
      });

      await UserService.getUsersByCustomerId(
        custId.value,
        filterActivity.value,
        "desc",
        0,
        50
      );

      disableAdd();
    };

    const isSuperAdmin = computed({
      get: () => store.state.auth.authUser.isSuperAdmin,
    });

    const salutations = computed({
      get: () => store.state.user.salutationsList,
    });

    const customerHasContent = computed({
      get: () => store.state.auth.authUser.customerHasContent,
    });
    const customerHasSas = computed({
      get: () => store.state.auth.authUser.customerHasSas,
    });

    // SAS status of the customer the user is being added to (returned with the categorizations),
    // as opposed to customerHasSas above, which is the logged-in admin's own customer.
    const targetCustomerHasSas = computed(
      () => store.state.user.categorizationsCustomerHasSas
    );
    const sasCategorizationsHint = computed(() => {
      if (!targetCustomerHasSas.value) {
        return "This customer has no SAS access, so SAS categorizations cannot be assigned.";
      }
      if (
        !firstCategorization.value.parentId &&
        !secondCategorization.value.parentId
      ) {
        return "No SAS categorizations have been defined for this customer yet.";
      }
      return "Assign the new user to the SAS categorizations of this customer.";
    });

    return {
      targetCustomerHasSas,
      sasCategorizationsHint,
      custId,
      filterActivity,
      firstCategorization,
      secondCategorization,
      openCancelPopup,
      cancelDialog,
      customerHasContent,
      customerHasSas,
      contentRolesForCreate,
      sasRolesForCreate,
      prefilledCustomer,
      show,
      disableAdd,
      createNewUser,
      user,
      salutations,
      router,
      isSuperAdmin,

      haveToSelectRule: [(val) => !!val || "Please select customer!"],
      requiredFieldRule: [
        (val) => (val && val.length > 0) || "Field is required!",
      ],
      requiredFieldRuleSalutation: [
        (val) => val !== null || "Field is required",
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || "Invalid email";
      },
      startDateOptionsFn(date) {
        return (
          date <= moment(user.person.endDate, "DD-MM-YYYY").format("YYYY/MM/DD")
        );
      },
      endDateOptionsFn(date) {
        return (
          date >=
          moment(user.person.startDate, "DD-MM-YYYY").format("YYYY/MM/DD")
        );
      },
    };
  },
};
</script>
